import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'En dos semanas de aplicar el Tomo 2 las rabietas en casa bajaron a la mitad. Por fin tengo un sistema, no solo buenas intenciones.',
  name: 'María T.',
  location: 'Madrid',
  detail: 'Madre de Alejandro, 8 años'
}, {
  quote: 'El Tomo de Vínculo me hizo llorar. Llevaba tres años sintiéndome un mal padre. Ahora tengo las herramientas y la confianza para ayudarle de verdad.',
  name: 'Carlos R.',
  location: 'Barcelona',
  detail: 'Padre de Lucía, 11 años'
}, {
  quote: 'Las cartas para el colegio del Bono 2 me ahorraron meses de lucha con el tutor. En una semana tenía las adaptaciones firmadas.',
  name: 'Ana M.',
  location: 'Valencia',
  detail: 'Madre de Marcos, 9 años'
}];
export function Testimonials() {
  return <section className="bg-surface-white py-10 px-6" data-id="element-374">
      <div className="max-w-6xl mx-auto" data-id="element-375">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-376">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-377">
              <div className="flex gap-1 mb-3" data-id="element-378">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-gold text-gold" data-id="element-379" />)}
              </div>
              <p className="text-primary text-lg italic mb-4 flex-grow" data-id="element-380">
                "{t.quote}"
              </p>
              <div data-id="element-381">
                <p className="font-bold text-primary" data-id="element-382">
                  {t.name}, {t.location}
                </p>
                <p className="text-secondary text-sm mt-1" data-id="element-383">{t.detail}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}